import { render, staticRenderFns } from "./SearchTonersInks.vue?vue&type=template&id=01810b82&"
import script from "./SearchTonersInks.vue?vue&type=script&lang=js&"
export * from "./SearchTonersInks.vue?vue&type=script&lang=js&"
import style0 from "./SearchTonersInks.vue?vue&type=style&index=0&id=01810b82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports